export { default } from './PartnerLogos';
